import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "c-search-container container-wide q-pb-xl q-pt-md" }
const _hoisted_2 = {
  key: 1,
  class: "row q-col-gutter-x-md q-col-gutter-y-lg"
}

import {computed, defineAsyncComponent, nextTick, ref} from 'vue';
import {useQuasar} from 'quasar';
import {useSearchStore} from 'src/apps/search/store';
import MasonryWall from '@yeger/vue-masonry-wall';
import {useRoute} from 'vue-router';
import FeedItemWrapper from 'src/apps/recommender/components/FeedItemWrapper.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'ExploreSearch',
  setup(__props) {

const searchStore = useSearchStore()

const $route = useRoute()
const $q = useQuasar()

const cmpMinCols = computed(() => {
  if ($q.screen.lt.sm) {
    return 1
  } else if ($q.screen.lt.md) {
    return 2
  } else if ($q.screen.lt.lg) {
    return 3
  } else {
    return 5
  }
})


const cat = computed(() => {
  const cat = $route.query?.cat?.toString()
  if (!cat) return
  return cat
})


const StoryListItem = defineAsyncComponent(() => import('src/apps/stories/components/StoryListItem.vue'))
const BlogListItem = defineAsyncComponent(() => import('src/components/blog/BlogListItem.vue'))


const getCatComponent = computed(() => {
  if (!cat.value) return

  switch (cat.value) {
    case 'stories':
      return StoryListItem
    case 'blogs':
      return BlogListItem
    default:
      return ''
  }
})

const initSkip = ref(true)

function onSkip() {
  if (!initSkip.value) return
  nextTick(() => {
    window.scrollTo(0, searchStore.searchScrollPos || 0)
    initSkip.value = false
  })
}

function getCatComponentData(item) {
  switch (cat.value) {
    case 'stories':
      return {modelValue: item}
    case 'blogs':
      return {modelValue: item}
    default:
      return {modelValue: item}
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!cat.value)
      ? (_openBlock(), _createBlock(_unref(MasonryWall), {
          key: 0,
          items: _unref(searchStore).searchResults?.explore?.items,
          "min-columns": cmpMinCols.value,
          "ssr-columns": 1,
          "column-width": 300,
          gap: 16,
          stagger: "0.03s",
          onRedraw: onSkip
        }, {
          default: _withCtx(({ item }) => [
            _createVNode(FeedItemWrapper, { "model-value": item }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["items", "min-columns"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchStore).searchResults?.explore?.items, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.uuid,
              class: "col-12 col-sm-6 col-md-4 col-lg-3"
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(getCatComponent.value), _mergeProps({ ref_for: true }, getCatComponentData(item)), null, 16))
            ]))
          }), 128))
        ]))
  ]))
}
}

})